"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoPaymentMethodsNotificationSchema = exports.PaymentMethodExpiredNotificationSchema = exports.NoPaymentMethodsPayloadSchema = exports.PaymentMethodsExpiredPayloadSchema = void 0;
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
exports.PaymentMethodsExpiredPayloadSchema = (0, core_1.StrictObject)({
    teamId: core_1.IdSchema,
    teamName: core_1.NameSchema,
});
exports.NoPaymentMethodsPayloadSchema = (0, core_1.StrictObject)({
    teamId: core_1.IdSchema,
    teamName: core_1.NameSchema,
});
exports.PaymentMethodExpiredNotificationSchema = (0, ruby_1.createNotificationMessageSchema)(ruby_1.NotificationType.PAYMENT_METHODS_EXPIRED, exports.PaymentMethodsExpiredPayloadSchema);
exports.NoPaymentMethodsNotificationSchema = (0, ruby_1.createNotificationMessageSchema)(ruby_1.NotificationType.NO_PAYMENT_METHODS, exports.NoPaymentMethodsPayloadSchema);
